import {
  VAT_NUMBER_LABEL, ADDRESS_CUSTOM_FIELDS, VAT_VALIDATED_LABEL, VAT_RAW_RESPONSE, SELF_DECLARATION_LABEL,
} from '~~/constants/commerceTools';
import type { VatValidationResult } from '~~/types/vatValidation';
import type { AddressType } from '~~/types/AddressType';
import type { CustomFieldInput, CustomFieldsDraft } from '~~/types/commercetools';
import { CheckoutClientType } from '~~/types/checkout/formData/checkoutClientType';

export type VatNumber = Maybe<string>;

export type SelfDeclaration = 'individual' | 'company';

const SELF_DECLARATION_BY_CLIENT_TYPE: Record<CheckoutClientType, SelfDeclaration> = {
  [CheckoutClientType.COMPANY]: 'company',
  [CheckoutClientType.PRIVATE]: 'individual',
};

export const getSelfDeclaration = (clientType: Maybe<CheckoutClientType>): SelfDeclaration | null =>
  (clientType ? SELF_DECLARATION_BY_CLIENT_TYPE[clientType] : null);

export const isSelfDeclaration = (value: unknown): value is SelfDeclaration =>
  value === 'company' || value === 'individual';

export interface SetAddressCustomFieldsParams {
  addressType: AddressType;
  vatNumber: Maybe<VatNumber>;
  vatResult?: Maybe<VatValidationResult>;
  selfDeclaration?: Maybe<SelfDeclaration>;
}

export const buildAddressCustomFieldsDraft = (fields: Array<CustomFieldInput>): CustomFieldsDraft => {

  return {
    type: {
      key: ADDRESS_CUSTOM_FIELDS,
    },
    fields,
  };

};

export const buildSelfDeclarationField = (selfDeclaration: SelfDeclaration): CustomFieldInput => {

  return {
    value: JSON.stringify(selfDeclaration),
    name: SELF_DECLARATION_LABEL,
  };

};

export const buildVatNumberField = (vatNumber: VatNumber): CustomFieldInput => {

  return {
    value: JSON.stringify(vatNumber),
    name: VAT_NUMBER_LABEL,
  };

};

export const buildVatRawResponseField = (vatResult: VatValidationResult): CustomFieldInput => {

  return {
    value: JSON.stringify(vatResult.response),
    name: VAT_RAW_RESPONSE,
  };

};

export const buildVatValidatedField = (vatValid: boolean): CustomFieldInput => {

  return {
    value: String(vatValid),
    name: VAT_VALIDATED_LABEL,
  };

};

export const setAddressCustomFieldsAction = (params: SetAddressCustomFieldsParams) => {

  const fields: Array<CustomFieldInput> = [];

  if (params.selfDeclaration) {

    fields.push(buildSelfDeclarationField(params.selfDeclaration));

  }

  if (params.vatNumber) {

    fields.push(buildVatNumberField(params.vatNumber));

  }

  if (params.vatResult) {

    fields.push(buildVatValidatedField(params.vatResult?.valid));
    fields.push(buildVatRawResponseField(params.vatResult));

  }

  return setAddressCustomType(params.addressType, fields);

};

export const clearAddressCustomFieldsAction = (
  addressType: AddressType,
  selfDeclaration: Maybe<SelfDeclaration> = undefined,
) => {

  return setAddressCustomType(addressType, selfDeclaration ? [buildSelfDeclarationField(selfDeclaration)] : []);

};

export const setAddressCustomType = (
  addressType: AddressType,
  fields: Array<CustomFieldInput>,
) => {

  return setCustomType(fields, ADDRESS_CUSTOM_FIELDS, `set${addressType}AddressCustomType`);

};


export const setCustomType = (fields: Array<CustomFieldInput>, key: string, customType: string) => {

  return {
    [customType]: {
      type: {
        key,
      },
      fields,
    },
  };

};
